import styled from 'styled-components';
import { mixins } from '@mindtickle/styles/lib';
import { tokens } from '@mindtickle/styles/lib';
import { DEFAULT_MAX_WIDTH } from '~/config/app.constants';

export const StyledLearnerShellLayout = styled.div`
  height: 100vh;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;

  &.is-impersonated {
    border-right: 4px solid ${tokens.borderTokens.COLOR_BORDER_ACCENT};
    border-bottom: 4px solid ${tokens.borderTokens.COLOR_BORDER_ACCENT};
    border-left: 4px solid ${tokens.borderTokens.COLOR_BORDER_ACCENT};
  }

  /* Reason for using min-width - https://leonardofaria.net/2020/07/18/using-flexbox-and-text-ellipsis-together */
  min-width: 0;
  display: flex;
  position: relative;
  flex-direction: column;

  .shell-layout-learner-content {
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
    position: relative;

    .shell-layout-learner-content-wrapper {
      flex: 1;
      height: 100%;
      min-width: 0;
      min-height: 0;
      display: flex;
      position: relative;
    }

    .shell-layout-content-area {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
  }

  @media screen and (max-width: ${DEFAULT_MAX_WIDTH.MOBILE}px) {
    .header-layout-wrapper,
    .learner-navigation-wrapper {
      display: none;
    }
  }

  &.layout-hidden {
    .header-layout-wrapper,
    .learner-navigation-wrapper {
      display: none;
    }
  }
`;

export const StyledBerryWidget = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: ${mixins.zIndex.POPOVER};
  font-size: 0;
  line-height: 0;
`;
